import config from 'src/config'

function load(component) {
  return () => import(`src/${component}.vue`)
}

const MODULE_PATH = '/sales/management/'

export default [
  {
    path: MODULE_PATH,
    component: load('containers/Full'),
    name: 'Sales',
    meta: {
      title: 'Common.menu.sales',
      menuItem: true,
      sorting: config.sidebar.menu.sorting.modules.sales,
      icon: 'attach_money',
    },
    children: [
      {
        path: MODULE_PATH + 'enrolment',
        component: load('application/sales/components/BackOfficeEnrolmentArea'),
        name: 'Enrolment',
        meta: {
          title: 'Enrolment',
          icon: 'attach_money',
          menuItem: true,
          sorting: 401,
        },
      },
      {
        path: MODULE_PATH + 'enrolment/view/[:saleID]',
        component: load('application/sales/components/BackOfficeEnrolmentArea'),
        name: 'Enrolment Detail',
        props: true,
        meta: {
          title: 'Enrolment Detail',
          icon: 'attach_money',
          menuItem: false,
          sorting: 402,
        },
      },
      {
        path: MODULE_PATH + 'enrolment/rental',
        component: load('application/sales/components/BackOfficeRentalEnrolmentArea'),
        name: 'Rental Enrolment',
        meta: {
          title: 'Rental Enrolment',
          icon: 'attach_money',
          menuItem: true,
          sorting: 403,
        },
      },
      {
        path: MODULE_PATH + 'enrolment/rental/view/[:saleID]',
        component: load('application/sales/components/BackOfficeRentalEnrolmentArea'),
        name: 'Rental Enrolment Detail',
        props: true,
        meta: {
          title: 'Rental Enrolment Detail',
          icon: 'attach_money',
          menuItem: false,
          sorting: 404,
        },
      },
      {
        path: MODULE_PATH + 'sales/list',
        component: load('application/sales/components/SalesList'),
        name: 'New Sales & Order History',
        meta: {
          title: 'Common.menu.sub.sales.newSalesOrderHistory',
          icon: 'attach_money',
          menuItem: true,
          sorting: 405,
        },
      },
      {
        path: MODULE_PATH + 'rental/list',
        component: load('application/sales/components/SalesList'),
        name: 'New Rental Sales & Rental Order History',
        meta: {
          title: 'New Rental Sales & Rental Order History',
          icon: 'attach_money',
          menuItem: true,
          sorting: 406,
          isRental: true,
        },
      },
      {
        path: MODULE_PATH + 'new',
        component: load('application/sales/components/SalesOrderArea'),
        name: 'New Sales Order',
        meta: {
          title: 'Common.menu.sub.sales.newSales',
          icon: 'attach_money',
          menuItem: false,
          sorting: 407,
        },
      },
      {
        path: MODULE_PATH + 'rental/view/[:saleID]',
        component: load('application/sales/components/RentalSalesOrderArea'),
        name: 'View Rental Sales Order',
        props: true,
        meta: {
          title: 'View Rental Sales Order',
          icon: 'attach_money',
          menuItem: false,
          sorting: 408,
        },
      },
      {
        path: MODULE_PATH + 'rental/new',
        component: load('application/sales/components/RentalSalesOrderArea'),
        name: 'New Rental Sales Order',
        props: true,
        meta: {
          title: 'New Rental Sales Order',
          icon: 'attach_money',
          menuItem: false,
          sorting: 409,
        },
      },
      {
        path: MODULE_PATH + 'view/[:saleID]',
        component: load('application/sales/components/SalesOrderArea'),
        name: 'View Sales Order',
        props: true,
        meta: {
          title: 'View Sales Order',
          icon: 'attach_money',
          menuItem: false,
          sorting: 410,
        },
      },
      {
        path: MODULE_PATH + 'cancellation/list',
        component: load('application/sales/components/SalesCancellationList'),
        name: 'Sales Order Cancellation List',
        meta: {
          title: 'Common.menu.sub.sales.sales_cancellation',
          icon: 'attach_money',
          menuItem: true,
          sorting: 412,
        },
      },
      {
        path: MODULE_PATH + 'cancellation/new',
        component: load('application/sales/components/SalesCancellationArea'),
        name: 'New Sales Cancellation',
        meta: {
          title: 'Common.menu.sub.sales.sales_cancellation',
          icon: 'attach_money',
          menuItem: false,
          sorting: 413,
        },
      },
      {
        path: MODULE_PATH + 'cancellation/view/[:cancellationID]',
        component: load('application/sales/components/SalesCancellationArea'),
        name: 'Sales Cancellation Detail',
        props: true,
        meta: {
          title: 'Common.menu.sub.sales.sales_cancellation',
          icon: 'attach_money',
          menuItem: false,
          sorting: 414,
        },
      },
      {
        path: MODULE_PATH + 'exchange/list',
        component: load('application/sales/components/SalesExchangeList'),
        name: 'Sales Exchange List',
        meta: {
          title: 'Common.menu.sub.sales.product_exchange',
          icon: 'attach_money',
          menuItem: true,
          sorting: 415,
        },
      },
      {
        path: MODULE_PATH + 'exchange/new',
        component: load('application/sales/components/SalesExchangeArea'),
        name: 'New Sales Exchange',
        meta: {
          title: 'Common.menu.sub.sales.product_exchange',
          icon: 'attach_money',
          menuItem: false,
          sorting: 416,
        },
      },
      {
        path: MODULE_PATH + 'exchange/view/[:exchangeID]',
        component: load('application/sales/components/SalesExchangeArea'),
        name: 'Sales Exchange Detail',
        props: true,
        meta: {
          title: 'Common.menu.sub.sales.product_exchange',
          icon: 'attach_money',
          menuItem: false,
          sorting: 417,
        },
      },
      {
        path: MODULE_PATH + 'cancellation/legacy/view/[:cancellationID]',
        component: load('application/sales/components/LegacySalesCancellationArea'),
        name: 'Legacy Sales Cancellation Detail',
        props: true,
        meta: {
          title: 'Legacy Sales Cancellation Detail',
          icon: 'attach_money',
          menuItem: false,
          sorting: 418,
        },
      },
      {
        path: MODULE_PATH + 'cancellation/legacy/new',
        component: load('application/sales/components/LegacySalesCancellationArea'),
        name: 'New Legacy Sales Cancellation',
        props: true,
        meta: {
          title: 'New Legacy Sales Cancellation',
          icon: 'attach_money',
          menuItem: false,
          sorting: 419,
        },
      },
      {
        path: MODULE_PATH + 'exchange/legacy/view/[:exchangeID]',
        component: load('application/sales/components/LegacySalesExchangeArea'),
        name: 'Legacy Product Exchange Detail',
        props: true,
        meta: {
          title: 'Legacy Product Exchange Detail',
          icon: 'attach_money',
          menuItem: false,
          sorting: 420,
        },
      },
      {
        path: MODULE_PATH + 'exchange/legacy/new',
        component: load('application/sales/components/LegacySalesExchangeArea'),
        name: 'New Legacy Product Exchange',
        props: true,
        meta: {
          title: 'New Legacy Product Exchange',
          icon: 'attach_money',
          menuItem: false,
          sorting: 421,
        },
      },
      {
        path: MODULE_PATH + 'report/daily',
        component: load('application/sales/components/SalesDailyReport'),
        name: 'Daily Sales Report',
        meta: {
          title: 'Daily Sales Report',
          icon: 'attach_money',
          menuItem: true,
          sorting: 422,
        },
      },
      {
        path: MODULE_PATH + 'aeon/list',
        component: load('application/sales/components/AeonPaymentList'),
        name: 'Aeon Payment List',
        meta: {
          title: 'Aeon Payment List',
          icon: 'attach_money',
          menuItem: true,
          sorting: 423,
        },
      },
      {
        path: MODULE_PATH + 'epp/list',
        component: load('application/sales/components/EPPPaymentList'),
        name: 'EPP Payment List',
        meta: {
          title: 'EPP Payment List',
          icon: 'attach_money',
          menuItem: true,
          sorting: 424,
        },
      },
      {
        path: MODULE_PATH + 'sale/transfer/list',
        component: load('application/sales/components/SalesTransferList'),
        name: 'Sale Transfer List',
        meta: {
          title: '@saleTransferList.title',
          icon: '',
          menuItem: true,
          sorting: 425,
        },
      },
      {
        path: MODULE_PATH + 'sale/transfer/new/[:saleID]',
        component: load('application/sales/components/SalesTransferArea'),
        name: 'New Sale Transfer',
        props: true,
        meta: {
          title: '@svTransferNew.title',
          icon: '',
          menuItem: false,
          sorting: 426,
        },
      },
      {
        path: MODULE_PATH + 'sale/transfer/view/[:saleID]',
        component: load('application/sales/components/SalesTransferArea'),
        name: 'Sale Transfer Details',
        props: true,
        meta: {
          title: '@svTransferDetails.title',
          icon: '',
          menuItem: false,
          sorting: 426,
        },
      },
      {
        path: MODULE_PATH + 'sv/month/amendment/list',
        component: load('application/sales/components/SalesSvMonthAmendmentList'),
        name: 'Sales SV Month Amendment List',
        meta: {
          title: '@svMonthAmendmentList.title',
          icon: '',
          menuItem: true,
          sorting: 425,
        },
      },
      {
        path: MODULE_PATH + 'sv/month/amendment/view/[:recordId]',
        component: load('application/sales/components/SalesSvMonthAmendmentArea'),
        name: 'Sales SV Month Amendment Details',
        props: true,
        meta: {
          title: '@svMonthAmendmentDetails.title',
          icon: '',
          menuItem: false,
          sorting: 426,
        },
      },
      {
        path: MODULE_PATH + 'sv/month/amendment/new/[:salesId]',
        component: load('application/sales/components/SalesSvMonthAmendmentArea'),
        name: 'New Sales SV Month Amendment',
        props: true,
        meta: {
          title: '@svMonthAmendmentDetails.title',
          icon: '',
          menuItem: false,
          sorting: 427,
        },
      },
      {
        path: MODULE_PATH + 'sv/transfer/by-product/list',
        component: load('application/sales/components/SalesSvTransferByProductList'),
        name: 'Sales SV Transfer By Product List',
        meta: {
          title: '@svTransferByProductList.title',
          icon: '',
          menuItem: true,
          sorting: 426,
        },
      },
      {
        path: MODULE_PATH + 'sv/transfer/by-product/view/[:recordId]',
        component: load('application/sales/components/SalesSvTransferByProductArea'),
        name: 'Sales SV Transfer By Product Details',
        props: true,
        meta: {
          title: '@svTransferByProductDetails.title',
          icon: '',
          menuItem: false,
          sorting: 427,
        },
      },
      {
        path: MODULE_PATH + 'sv/transfer/by-product/new',
        component: load('application/sales/components/SalesSvTransferByProductArea'),
        name: 'Sales SV Transfer By Product New',
        meta: {
          title: '@svTransferByProductNew.title',
          icon: '',
          menuItem: false,
          sorting: 427,
        },
      },
    ],
  },
]
